import * as angular from 'angular';
import { PageSorting } from 'app/custom';
import { ReportsService } from 'app/_services/reportsService';

export type ColumnFilterSearchParamFetcherFunction = (search: any) => {
    [key: string]: any;
};

function getColumnFilterFetcher(
    reportsService: ReportsService
): ColumnFilterSearchParamFetcherFunction {
    return (search: any) => {
        const options: { [key: string]: any } = {};
        options.favoritesOnly = search.favoritesOnly === 'true';
        options.networkPointName = search.networkPointName;
        options.tso = search.tso;
        options.direction = search.direction;
        options.runtimeFrom = search.runtimeFrom;
        options.runtimeTo = search.runtimeTo;
        options.procedure = search.procedure;
        options.capacityCategory = search.capacityCategory;
        if (search.tradingCloseFrom !== 'NONE') {
            options.tradingCloseFrom =
                search.tradingCloseFrom || reportsService.getDateRange('start');
        } else {
            options.tradingCloseFrom = undefined;
        }
        options.tradingCloseTo = search.tradingCloseTo;
        options['amount-min'] = search['amount-min'] && +search['amount-min'];
        options['amount-max'] = search['amount-max'] && +search['amount-max'];
        return options;
    };
}
angular
    .module('app')
    .factory(
        'fetchColumnFilterOptionsFromSearchParams',
        getColumnFilterFetcher
    );

export function prepareSearchParams(
    columnFilterOptions: { [key: string]: any },
    pageSortingOptions: PageSorting,
    pagingSetting: any,
    pageNumber: number
): any {
    const locationParams = angular.extend(
        angular.copy(columnFilterOptions),
        angular.copy(pageSortingOptions),
        angular.copy(pagingSetting),
        { pageNumber: pageNumber }
    );
    if (locationParams.tradingCloseFrom == null) {
        locationParams.tradingCloseFrom = 'NONE'; //save to prevent default value
    }
    return locationParams;
}

export function getPagingSettings(search: any): {
    pageNumber: number;
    sortingOptions: { sortAscending: boolean; sortColumn: any };
} {
    return {
        pageNumber: parseInt(search.pageNumber, 10) || 1,
        sortingOptions: {
            sortAscending: search.sortAscending === 'true',
            sortColumn: search.sortColumn
        }
    };
}
